export const getRandomIntInclusive = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
};

// Deterministic alternative to getRandomIntInclusive for use during SSR.
// Math.random() produces a different value on the server render vs the client
// hydration render, causing React hydration mismatches. Hashing a stable seed
// (e.g. derived from the data being rendered) gives the same "random-looking"
// result on both server and client.
export const getSeededIntInclusive = (seed: string, min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0; // force 32-bit integer
  }
  return min + (Math.abs(hash) % (max - min + 1));
};
